/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}
const convertBuildWeekToDate = params => formatGivenDate( params.data.codesBuildWeek, 'DD-MMM-YY' );
const convertOrderBuildWeekToDate = params => formatGivenDate( params.data.orderBuildWeek, 'DD-MMM-YY' );
const convertDeliveryToDate = params => formatGivenDate( params.data.reqDeliveryDate, 'DD-MMM-YY' );

const colDefs = [
    {
        field: 'effectiveFamily',
        headerName: 'Family',
        width: 120,
        sortable: true,
        filter: true
    },
    {
        field: 'model',
        headerName: 'Model',
        width: 120,
        sortable: true,
        filter: true
    },
    {
        field: 'orderingCode',
        headerName: 'Ordering Code',
        width: 155,
        sortable: true,
        filter: true,
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=${params.data.orderOrGroup}&constraintkey=${params.data.orderingCode}`}>{params.value}</Link> )
    },
    {
        field: 'codesBuildWeek',
        headerName: 'Order Build Week',
        width: 165,
        sortable: true,
        filter: true,
        valueGetter: convertBuildWeekToDate
    },
    {
        field: 'orderBuildWeek',
        headerName: 'Original Build Week',
        width: 185,
        sortable: true,
        filter: true,
        valueGetter: convertOrderBuildWeekToDate
    },
    {
        field: 'reqDeliveryDate',
        headerName: 'RDD Date',
        width: 125,
        sortable: true,
        filter: true,
        valueGetter: convertDeliveryToDate
    },
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        width: 150,
        sortable: true,
        filter: true,
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.data.orderNumber}`}>{params.value}</Link> )
    },
    {
        field: 'orderOrGroup',
        headerName: 'Order or Group',
        width: 155,
        sortable: true,
        filter: true
    },
    {
        field: 'retailIndicator',
        headerName: 'Retail Indicator',
        width: 155,
        sortable: true,
        filter: true
    },
    {
        field: 'earlyShipInd',
        headerName: 'Early Ship Indicator',
        width: 185,
        sortable: true,
        filter: true
    },
    {
        field: 'activityType',
        headerName: 'Activity Type',
        width: 135,
        sortable: true,
        filter: true
    },
    {
        field: 'orderingCodeQty',
        headerName: 'Order Quantity',
        width: 155,
        sortable: true,
        filter: true
    }
];

const OrderPushedOutTable = props => (
    <section className="atp-search-result-panel order-pushed-out-result-panel ">
        <div className="results-message">
            {`${props.totalRows} records found.`}
        </div>
        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>
    </section>
);

OrderPushedOutTable.propTypes = {
    results: PropTypes.array.isRequired,
    totalRows: PropTypes.number
};
export default OrderPushedOutTable;
